// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Tooltip';



// WEBPACK FOOTER //
// ./components/Tooltip/index.js